<template>
  <div class="result-wrap">
    <div class="card-wrap">
      <div v-if="score == 5" class="success">胜利</div>
      <div v-else class="fail">失败</div>
      <div class="user-info">
        <van-image
          :class="['avator', score == 5 ? 'with-crown' : '']"
          v-if="user"
          :src="user.avatar || require('@/assets/unlogin-avatar.png')"
          alt="头像"
          round
          fit="cover"
        />
      </div>
      <div class="user-name">{{ user.nickname }}</div>
      <div class="content">
        <div class="result-desc">{{ tip }}</div>
        <img
          v-if="Number(score) > 3"
          class="result-img"
          src="@/assets/img/result-icon.png"
          alt="结果奖杯icon"
        />
        <img
          v-else
          class="result-img"
          src="@/assets/img/result-icon-grey.png"
          alt="结果奖杯icon"
        />
        <div class="result-info">
          <div class="result-divider"></div>
          <van-row
            class="score-items"
            type="flex"
            justify="center"
            align="center"
            gutter="50"
          >
            <van-col span="12">
              <div class="score-label">本次得分：{{ score }}</div>
            </van-col>
            <van-col span="12">
              <div class="score-label">
                用时：{{ duration | durationFormat }}
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <van-row class="btns" type="flex" gutter="8">
      <van-col span="24">
        <div class="btn-outer" @click="shareResult">
          <div class="btn-inner">炫耀成绩</div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="btn-outer" @click="goErrors">
          <div class="btn-inner">查看题目解析</div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="btn-outer" @click="$router.replace('/')">
          <div class="btn-inner">返回</div>
        </div>
      </van-col>
    </van-row>
    <van-dialog
      v-model="showPrizePopup"
      class="draw-dialog"
      title=""
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      <div class="draw-dialog_content">
        <div class="draw-label">恭喜您！</div>
        <div class="draw-info">获得1次抽奖机会</div>
        <div class="draw-btn" @click="doDraw"></div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="shareDialog"
      class="share-dialog"
      title=""
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog_content">
        <div>
          <img
            style="width: 100%; height: 100%; vertical-align: middle"
            id="cerImg"
            :src="imgSrc"
          />
        </div>
        <img
          class="close-btn"
          src="@/assets/img/close-btn.png"
          @click="shareDialog = false"
        />
      </div>
    </van-dialog>
    <div id="shareImg">
      <div style="text-align: center">
        <div class="share-top">
          <div v-if="score == 5" class="success">胜利</div>
          <div v-else class="fail">失败</div>
          <div class="user-info">
            <van-image
              :class="['avator', score == 5 ? 'with-crown' : '']"
              v-if="user"
              :src="user.avatar || require('@/assets/unlogin-avatar.png')"
              alt="头像"
              round
              fit="cover"
            />
          </div>
          <div class="user-name">{{ user.nickname }}</div>
          <img v-if="Number(score) > 3" src="@/assets/img/result-icon.png" />
          <img v-else src="@/assets/img/result-icon-grey.png" />
          <div class="top-info">
            <div class="top-score">
              “{{ score }}<span class="score-measure">分</span>”
            </div>
            <div class="top-time">用时：{{ duration | durationFormat }}</div>
          </div>
        </div>
        <div class="share-divider">
          <img src="@/assets/img/card-divider.png" />
        </div>
        <div class="share-info">
          <div class="share-desc">
            <div>2026年山西省公众科学素质网络知识竞赛</div>
            <div class="share-tip">长按扫码进入即可参与挑战</div>
          </div>
          <img class="qr-code" :src="qrCodeSrc" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      //   score: 0,
      //   totalScore: 5,
      //   duration: 0,
      // 抽奖弹出层
      showPrizePopup: false,
      // 抽中红包弹窗
      // redPackDialog: false,
      // 未抽中弹窗
      // missDialog: false,
      shareDialog: false,
      imgSrc: "",
    };
  },
  computed: {
    ...mapState("versus", ["gameResult", "gameStatus"]),
    type() {
      return Number(this.$route.query.type);
    },
    tip() {
      switch (Number(this.score)) {
        case 0:
          return "失败乃成功之母，加油！";
        case 1:
          return "您已迈出成功的第一步，继续突破吧！";
        case 2:
          return "您已迈出成功的第一步，继续突破吧！";
        case 3:
          return "胜利在望，加油！";
        case 4:
          return "胜利在望，加油！";
        case 5:
          return "优秀如你，再接再厉！";
        default:
          return "优秀如你，再接再厉！";
      }
    },
    user() {
      return this.$store.state.user.user;
    },
    // 根据打包环境区分二维码：线上环境用 qr-code.png，其余用 qr-code2.png
    qrCodeSrc() {
      if (process.env.VUE_APP_ENV === "production") {
        return require("@/assets/img/qr-code.png");
      }
      return require("@/assets/img/qr-code2.png");
    },
    score() {
      console.log(this.$store.state.versus.gameResult, "*&*&*&*");

      return this.$store.state.versus.gameResult?.score;
    },
    duration() {
      return this.$store.state.versus.gameResult?.duration;
    },
  },
  methods: {
    async doDraw() {
      this.$router.replace(
        `/draw?score=${this.score}&duration=${this.duration}&type=2`
      );
    },
    async hasDrawChance() {
      try {
        // if (Number(this.score) > 3) {
        const res = await this.$axios.post(`/Redpackets/getLotteryNum`);
        if (res.data.success) {
          this.showPrizePopup = true;
        }
        // }
      } catch (error) {
        console.log(error);
      }
    },
    async checkFirst() {
      try {
        await this.$axios.post(`/Question/checkFirst`, {
          uid: this.$store.state.user.user.id,
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 炫耀成绩
    shareResult() {
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.querySelector("#shareImg"), {
            dpi: 96, // 分辨率
            scale: 1, // 设置缩放
            useCORS: true,
            bgcolor: "#ffff", // 应该这样写
            logging: false, // 打印日志用的 可以不加默认为false
          })
            .then((canvas) => {
              return new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob));
              });
            })
            .then((blob) => {
              const fr = new FileReader();
              fr.readAsDataURL(blob);
              fr.onload = (e) => {
                this.imgSrc = e.target.result;
              };
              // const url = URL.createObjectURL(blob);
              // this.imgSrc = url;
              this.shareDialog = true;
            });
        });
      }, 100);
    },
    goErrors() {
      this.$router.replace(
        `/errors?type=3&score=${this.score}&duration=${this.duration}`
      );
    },
  },
  created() {
    if (Number(this.$route.query.type) !== 2) {
      this.hasDrawChance();
      this.checkFirst();
    }
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  position: relative;
  padding: 50px 12px 0;
  @include content-bg;
  @include safe-area-bottom;
  .draw-dialog {
    width: 228px;
    background-color: transparent;
    .draw-dialog_content {
      position: relative;
      width: 100%;
      height: 323px;
      text-align: center;
      background: url("~@/assets/img/draw-icon.png") no-repeat top center/100%;
      .draw-label {
        padding-top: 103px;
        font-size: 20px;
        font-weight: 600;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-info {
        margin-top: 3px;
        font-size: 14px;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
      }
    }
  }
  .card-wrap {
    padding: 5px 15px;
    margin: 0 15px 15px;
    background: #fff;
    border-radius: 50px;
    .success,
    .fail {
      font-size: 24px;
      font-weight: 500;
      color: #1480b3;
      text-align: center;
    }
    .success {
      color: red;
    }
    .user-info {
      margin-top: 20px;
      text-align: center;
      .avator {
        position: relative;
        width: 40px;
        overflow: visible;
      }
      .with-crown::before {
        position: absolute;
        top: -15px;
        left: 10px;
        z-index: 100;
        display: inline-block;
        width: 20px;
        height: 20px;
        content: "";
        background: url("~@/assets/img/crown.png") no-repeat top center/100%;
      }
    }
    .content {
      text-align: center;
      .result-desc {
        margin-top: 12px;
        font-size: 15px;
        font-weight: 500;
        color: #1480b3;
      }
      .result-img {
        width: 150px;
        height: 144px;
        margin-top: 20px;
      }
      .result-info {
        .result-divider {
          padding-left: 12px;
          margin-top: 12px;
          border-bottom: 1px solid #eee;
        }
        .score-items {
          padding: 15px 20px 20px;
          font-size: 15px;
          font-weight: 500;
          line-height: 21px;
          color: #1480b3;
        }
      }
    }
    .user-name {
      font-size: 13px;
      color: #404f6b;
      text-align: center;
    }
  }
  .btns {
    padding: 0 30px;
    .btn-outer {
      margin-top: 13px;
    }
  }

  .share-dialog {
    width: 90%;
    overflow: visible;
    border-radius: 0;
    .dialog_content {
      position: relative;
      .close-btn {
        position: absolute;
        top: calc(100% + 10px);
        left: calc(50% - 15px);
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
  #shareImg {
    position: absolute;
    left: 99999px;
    width: 566px;
    padding: 96px 34px 40px;
    background: url("~@/assets/img/plain-bg.png") no-repeat top center/100%;
    .share-top {
      padding: 20px;
      background: #fff;
      border-radius: 18px 18px 0 0;
      .success,
      .fail {
        font-size: 36px;
        font-weight: 500;
        color: #1480b3;
        text-align: center;
      }
      .success {
        color: red;
      }
      .user-info {
        margin-top: 20px;
        text-align: center;
        .avator {
          position: relative;
          width: 80px;
          overflow: visible;
        }
        .with-crown::before {
          position: absolute;
          top: -25px;
          left: 20px;
          z-index: 100;
          display: inline-block;
          width: 40px;
          height: 40px;
          content: "";
          background: url("~@/assets/img/crown.png") no-repeat top center/100%;
        }
      }
      .user-name {
        font-size: 26px;
        color: #404f6b;
        text-align: center;
      }
      img {
        width: 230px;
        height: 224px;
      }
      .top-label {
        margin-top: 26px;
        font-size: 34px;
        font-weight: 600;
        line-height: 38px;
        color: #333;
      }
      .top-area {
        margin-top: 8px;
        font-size: 25px;
        line-height: 28px;
        color: #333;
      }
      .top-score {
        margin-top: 24px;
        font-size: 64px;
        font-weight: 600;
        line-height: 76px;
        color: #46a87d;
        .score-measure {
          font-size: 28px;
          font-weight: 400;
          line-height: 32px;
          color: #46a87d;
        }
      }
      .top-time {
        padding: 24px 0 50px;
        font-size: 25px;
        font-weight: 400;
        line-height: 28px;
        color: #46a87d;
      }
    }
    .share-divider {
      margin: -1px 0 -9px;
      img {
        width: 566px;
      }
    }
    .share-info {
      display: flex;
      padding: 10px 10px;
      background: #ffff;
      border-radius: 0 0 18px 18px;
      .share-desc {
        padding: 30px 10px;
        font-size: 24px;
        color: #333;
        text-align: left;
        .share-tip {
          margin-top: 20px;
          font-size: 20px;
          color: 999;
        }
      }
      .qr-code {
        width: 150px;
        height: 150px;
      }
    }
  }
}
</style>
